package com.solevo.dist.network.implementation.http.api.quotes

import com.solevo.dist.application.models.AnswerQuoteRequest
import com.solevo.dist.application.models.QuoteRequest
import com.solevo.dist.application.models.SalesAgreementRequest
import com.solevo.dist.network.api.quotes.QuoteRemoteSource
import com.solevo.dist.network.implementation.http.HttpSpecification
import com.solevo.libraries.feature.authentication.accessToken.AccessToken
import com.solevo.libraries.network.infrastructure.HttpMethod
import com.solevo.libraries.network.infrastructure.NetworkClient
import com.solevo.libraries.network.infrastructure.NetworkRequest
import com.solevo.libraries.network.infrastructure.request
import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.withContext
import kotlinx.serialization.json.Json

class QuoteHttpRemoteSource(
    private val dispatcher: CoroutineDispatcher,
    private val baseUrl: String,
    private val networkClient: NetworkClient,
    private val json: Json
): QuoteRemoteSource {

    override suspend fun createQuote(body: QuoteRequest, accessToken: AccessToken): Result<Unit> = withContext(dispatcher) {
        kotlin.runCatching {
            val request = NetworkRequest(
                url = "$baseUrl${HttpSpecification.Quote.createQuotePath}",
                method = HttpMethod.PUT,
                headers = mapOf("Authorization" to "Bearer ${accessToken.token}"),
                body = json.encodeToString(body)
            )
            networkClient.request<Unit>(request).getOrThrow()
        }
    }

    override suspend fun updateQuote(body: QuoteRequest, accessToken: AccessToken): Result<Unit> = withContext(dispatcher) {
        kotlin.runCatching {
            val request = NetworkRequest(
                url = "$baseUrl${HttpSpecification.Quote.updateQuotePath}",
                method = HttpMethod.POST,
                headers = mapOf("Authorization" to "Bearer ${accessToken.token}"),
                body = json.encodeToString(body)
            )
            networkClient.request<Unit>(request).getOrThrow()
        }
    }

    override suspend fun acceptQuote(body: AnswerQuoteRequest, accessToken: AccessToken): Result<Unit> = withContext(dispatcher) {
        kotlin.runCatching {
            val request = NetworkRequest(
                url = "$baseUrl${HttpSpecification.Quote.acceptQuotePath}",
                method = HttpMethod.POST,
                headers = mapOf("Authorization" to "Bearer ${accessToken.token}"),
                body = json.encodeToString(body)
            )
            networkClient.request<Unit>(request).getOrThrow()
        }
    }

    override suspend fun rejectQuote(body: AnswerQuoteRequest, accessToken: AccessToken): Result<Unit> = withContext(dispatcher) {
        kotlin.runCatching {
            val request = NetworkRequest(
                url = "$baseUrl${HttpSpecification.Quote.rejectQuotePath}",
                method = HttpMethod.POST,
                headers = mapOf("Authorization" to "Bearer ${accessToken.token}"),
                body = json.encodeToString(body)
            )
            networkClient.request<Unit>(request).getOrThrow()
        }
    }

    override suspend fun cancelQuote(body: AnswerQuoteRequest, accessToken: AccessToken): Result<Unit> = withContext(dispatcher) {
        kotlin.runCatching {
            val request = NetworkRequest(
                url = "$baseUrl${HttpSpecification.Quote.cancelQuotePath}",
                method = HttpMethod.POST,
                headers = mapOf("Authorization" to "Bearer ${accessToken.token}"),
                body = json.encodeToString(body)
            )
            networkClient.request<Unit>(request).getOrThrow()
        }
    }

    override suspend fun createSalesAgreement(body: SalesAgreementRequest, accessToken: AccessToken): Result<Unit> = withContext(dispatcher) {
        kotlin.runCatching {
            val request = NetworkRequest(
                url = "$baseUrl${HttpSpecification.Quote.createSalesAgreementPath}",
                method = HttpMethod.PUT,
                headers = mapOf("Authorization" to "Bearer ${accessToken.token}"),
                body = json.encodeToString(body)
            )
            networkClient.request<Unit>(request).getOrThrow()
        }
    }
}